import { __decorate } from "tslib";
import { MediaFrontendSharedModule } from '@common/media/frontend-shared';
import { FrontendFeaturePlugin } from '@core/frontend-shared/feature';
import { ClassName } from '@core/shared/class-name';
import * as i0 from "@angular/core";
let MediaFrontendFeature = /*#__PURE__*/(() => {
  let MediaFrontendFeature = class MediaFrontendFeature extends FrontendFeaturePlugin {
    getFeatureContext() {
      return {"package":"@common/media/frontend","featureId":"common-media"};
    }
    getFeatureFunctionality(functionality) {}
    static {
      this.ɵfac = /*@__PURE__*/(() => {
        let ɵMediaFrontendFeature_BaseFactory;
        return function MediaFrontendFeature_Factory(__ngFactoryType__) {
          return (ɵMediaFrontendFeature_BaseFactory || (ɵMediaFrontendFeature_BaseFactory = i0.ɵɵgetInheritedFactory(MediaFrontendFeature)))(__ngFactoryType__ || MediaFrontendFeature);
        };
      })();
    }
    static {
      this.ɵmod = /*@__PURE__*/i0.ɵɵdefineNgModule({
        type: MediaFrontendFeature
      });
    }
    static {
      this.ɵinj = /*@__PURE__*/i0.ɵɵdefineInjector({
        imports: [MediaFrontendSharedModule]
      });
    }
  };
  MediaFrontendFeature = __decorate([ClassName("MediaFrontendFeature")], MediaFrontendFeature);
  return MediaFrontendFeature;
})();
export { MediaFrontendFeature };